import { Container, Divider, Skeleton, Stack, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import { ErrorBoundary } from "components/ErrorBoundary";
import { InfoCard } from "components/InfoCard";
import { TierCircle } from "components/TierCircle";
import { SMTooltip } from "components/lib/SMTooltip";
import { useHostActivePlayerSummary } from "services/api/SWRService";

const cellStyles = {
  left: {
    paddingLeft: 0,
    textAlign: "left",
    fontWeight: 700,
    fontSize: "16px",
  },
  right: {
    paddingRight: 0,
    textAlign: "right",
    fontWeight: 400,
    fontSize: "16px",
  },
};

const styles = {
  infoCardBackground: {
    width: "100%",
    backgroundColor: `rgba(255, 255, 255, 0.03) !important`,
  },
};
export const HostSummaryByTier = () => {
  const { data: playerTierSummary, error, mutate } = useHostActivePlayerSummary();

  if (!playerTierSummary) return <SummaryByTierSkeleton />;

  const { totalHosted, totalCarded, nonCarded } = playerTierSummary;

  //TODO: Adjust the values of carded and non-carded once API data has been fixed

  return (
    <ErrorBoundary error={error} onRetry={() => mutate(undefined, { revalidate: true })}>
      <Stack spacing={2}>
        <Stack direction="row" justifyContent="center" spacing={2}>
          <InfoCard
            title={
              <Typography align="center">
                <strong>Total Carded</strong>
              </Typography>
            }
            cardSx={styles.infoCardBackground}
            value={
              <Typography align="center">
                <SMTooltip arrow title={"Current number of players on the floor which are hosted by you."}>
                  <strong>{totalHosted}</strong>
                </SMTooltip>{" "}
                of{" "}
                <SMTooltip arrow title={"Current number of carded players on the floor."}>
                  <strong>{totalCarded}</strong>
                </SMTooltip>
              </Typography>
            }
          />
          <InfoCard
            title={
              <Typography align="center">
                <strong>Non-Carded</strong>
              </Typography>
            }
            cardSx={styles.infoCardBackground}
            value={
              <Typography align="center">
                <SMTooltip arrow title={"Current number of active non-carded sessions on the floor."}>
                  <strong>{nonCarded}</strong>
                </SMTooltip>
              </Typography>
            }
          />
        </Stack>
        <Stack divider={<Divider />} spacing={2}>
          {playerTierSummary.tiers.map((tier, i) => (
            <Stack direction="row" key={`tier-summary-row-${tier.tierLevel}-${i}`} justifyContent="space-between">
              <Stack direction="row" spacing={1} alignItems="center">
                <TierCircle color={tier.primaryColor} />
                <Typography>{tier.tierLevel}</Typography>
              </Stack>
              <Typography>
                <SMTooltip
                  arrow
                  title={`Current number of ${tier.tierLevel} players on the floor which are hosted by you.`}
                >
                  <strong>{tier.hosted}</strong>
                </SMTooltip>{" "}
                of{" "}
                <SMTooltip arrow title={`Current number of ${tier.tierLevel} players on the floor.`}>
                  <strong>{tier.total}</strong>
                </SMTooltip>
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </ErrorBoundary>
  );
};

const SummaryByTierSkeleton = () => {
  return (
    <Container>
      <Stack direction="row" justifyContent="center" spacing={2}>
        <InfoCard
          title={
            <Typography align="center">
              <strong>Total Carded</strong>
            </Typography>
          }
          cardSx={styles.infoCardBackground}
          value={undefined}
        />
        <InfoCard
          title={
            <Typography align="center">
              <strong>Non-Carded</strong>
            </Typography>
          }
          cardSx={styles.infoCardBackground}
          value={undefined}
        />
      </Stack>
      <Table>
        <TableBody>
          {new Array(5).fill(1).map((tier, index) => (
            <TableRow key={`summary-by-tier-skeleton-${index}`}>
              <TableCell sx={cellStyles.left}>
                <Skeleton variant="rectangular" />
              </TableCell>
              <TableCell sx={cellStyles.right}>
                <Skeleton variant="rectangular" />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Container>
  );
};
